<template>
  <div>
    <b-card
      no-body
      class="my-1"
      :class="{ 'card-transparent-background': type == 'register' }"
    >
      <b-card-header
        class=""
        :class="{
          'card-header-profile-border': type == 'profile' || type == 'edit',
          'card-header-form-doorder': type == 'register',
        }"
      >
        <b-row>
          <b-col lg="7" md="6"><h4>Location Details</h4> </b-col>
          <b-col lg="5" md="6"
            ><div
              class="justify-content-right float-right"
              v-if="type != 'profile'"
            >
              <b-button
                type="button"
                variant="doorder-primary"
                class="
                  btn-bumblebee
                  btn-doorder
                  btn-doorder-filter
                  btn-doorder-add-item
                  mt-0
                "
                @click="addLocation()"
              >
                Add location
              </b-button>
            </div></b-col
          >
        </b-row>
      </b-card-header>

      <b-card-body
        class=""
        :class="{
          'py-2 px-4': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col
              md="12"
              class="my-2 mb-4"
              :class="{
                'profile-border-div-doorder':
                  type == 'profile' || type == 'edit',
              }"
              v-for="(location, index) in locations"
              :key="index + 1"
            >
              <h5 class="location-label-doorder card-title">
                Location {{ index + 1 }}
                <span
                  v-if="index != 0 && type != 'profile'"
                  class="float-sm-right"
                >
                  <img
                    class="remove-icon-doorder"
                    src="@/assets/images/doorder/remove-icon.png"
                    @click="removeLocation(index)"
                  />
                </span>
              </h5>
              <b-row>
                <b-col sm="6">
                  <b-form-group
                    :label="type == 'register' ? '' : 'Address'"
                    :label-for="'location' + (index + 1)"
                    label-class="form-label-doorder"
                    class="h-100 form-group-textarea-doorder form-group-doorder"
                  >
                    <p
                      v-if="location.invalid_address"
                      class="error_validation_message_p"
                    >
                      Please enter address
                    </p>
                    <b-form-textarea
                      v-if="type == 'register' || type == 'edit'"
                      :id="'location' + (index + 1)"
                      class="form-control-doorder"
                      v-model="location.address"
                      :name="'address' + (index + 1)"
                      placeholder="Address"
                      rows="7"
                      required
                      >{{ location.address }}</b-form-textarea
                    >
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ location.address }}
                    </span>

                    <input
                      :id="'latitude_' + (index + 1)"
                      :name="'latitude_' + (index + 1)"
                      v-model="location.latitude"
                      type="hidden"
                    />
                    <input
                      :id="'longitude_' + (index + 1)"
                      :name="'longitude_' + (index + 1)"
                      v-model="location.longitude"
                      type="hidden"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Postcode/Eircode'"
                    :label-for="'post_code' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      v-if="location.invalid_post_code"
                      class="error_validation_message_p"
                    >
                      Please select postcode
                    </p>
                    <!-- <GmapAutocomplete
                      class="form-control form-control-doorder"
                      :ref="'post_code' + (index + 1)"
                      :id="'post_code' + (index + 1)"
                      :options="autocompleteOptions"
                      fields="['name']"
                      @place_changed="setPlace"
                      v-on:placechanged="setPlace"
                    /> -->
                    <vue-google-autocomplete
                      v-if="type == 'register' || type == 'edit'"
                      :id="'post_code_' + (index + 1)"
                      classname="form-control form-control-doorder h-auto"
                      placeholder="Postcode/Eircode"
                      types="postal_code"
                      v-model="location.post_code"
                      :country="['ie', 'gb']"
                      v-on:placechanged="savePlace"
                      v-on:error="handleError"
                      v-on:inputChange="inputChange"
                      v-on:change="changeT('post_code_' + (index + 1))"
                      required
                    >
                    </vue-google-autocomplete>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ location.post_code }}
                    </span>
                  </b-form-group>
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Country'"
                    :label-for="'country' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="location.invalid_country"
                    >
                      Please select country
                    </p>
                    <v-select
                      v-if="type == 'register' || type == 'edit'"
                      :options="countryList"
                      v-model="location.country"
                      :name="'country' + (index + 1)"
                      :reduce="(item) => item.code"
                      placeholder="Select country"
                      required
                    ></v-select>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ location.country }}
                    </span>
                  </b-form-group>
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'County'"
                    :label-for="'county' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      class="error_validation_message_p"
                      v-if="location.invalid_county"
                    >
                      Please select county
                    </p>
                    <v-select
                      v-if="type == 'register' || type == 'edit'"
                      :options="countyList"
                      v-model="location.county"
                      :name="'county' + (index + 1)"
                      :reduce="(item) => item.code"
                      placeholder="Select county"
                      required
                    ></v-select>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ location.county }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-form-group
                    class="form-group-doorder"
                    :label="type == 'register' ? '' : 'Working days and hours'"
                    :label-for="'business_hours' + (index + 1)"
                    label-class="form-label-doorder"
                  >
                    <p
                      v-if="location.invalid_business_hours"
                      class="error_validation_message_p"
                    >
                      Please select business hours
                    </p>
                    <b-form-textarea
                      v-if="type == 'register' || type == 'edit'"
                      :id="'business_hours' + (index + 1)"
                      class="form-control-doorder"
                      v-model="location.business_hours"
                      :name="'business_hours' + (index + 1)"
                      placeholder="Working days and hours"
                      rows="4"
                      required
                      @click="openBusinessHoursModel(index)"
                      >{{ location.business_hours }}</b-form-textarea
                    >
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-doorder"
                    >
                      {{ location.business_hours }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
    <!-- Workig Hours Modal -->
    <b-modal
      id="business-hours-doorder-modal"
      modal-class="business-hours-doorder-modal"
      title="Availability"
      scrollable
      hide-footer
      ><b-form @submit.prevent="clickConfirm"
        ><business-hours
          :days="days"
          type="select"
          @updated-hours="updatedHours"
          color="#E9C218"
          :switchWidth="80"
        ></business-hours>
        <b-row class="justify-content-center w-100">
          <b-col lg="3" md="6" class="text-center">
            <b-button
              variant="doorder-primary"
              class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
              type="submit"
            >
              Yes
            </b-button>
          </b-col>

          <b-col lg="3" md="6" class="text-center">
            <b-button
              type="button"
              variant="doorder-danger-outline"
              class="btn-bumblebee btn-doorder btn-doorder-submit w-100"
              @click="closeModal"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-form></b-modal
    >
  </div>
</template>
 
<script>
import BusinessHours from "@/components/vue-business-hours/BusinessHoursDoorder.vue";
import $ from "jquery";
import moment from "moment";
import VueGoogleAutocomplete from "vue-google-autocomplete";

const days_default = {
  sunday: [
    {
      open: "",
      close: "",
      id: "1",
      isOpen: false,
    },
  ],
  monday: [
    {
      open: "",
      close: "",
      id: "2",
      isOpen: false,
    },
  ],
  tuesday: [
    {
      open: "",
      close: "",
      id: "3",
      isOpen: false,
    },
  ],
  wednesday: [
    {
      open: "",
      close: "",
      id: "4",
      isOpen: false,
    },
  ],
  thursday: [
    {
      open: "",
      close: "",
      id: "5",
      isOpen: false,
    },
  ],
  friday: [
    {
      open: "",
      close: "",
      id: "6",
      isOpen: false,
    },
  ],
  saturday: [
    {
      open: "",
      close: "",
      id: "7",
      isOpen: false,
    },
  ],
};

export default {
  name: "LocationDetails",
  components: { VueGoogleAutocomplete, BusinessHours },
  props: ["type", "locations"],
  data() {
    return {
      // locations: [{ address: "", post_code: "", business_hours: "" }],
      countryList: [{ label: "Ireland", code: "Ireland" }],
      countyList: [{ label: "Dublin", code: "Dublin" }],
      // invalid_country: false,
      // invalid_county: false,
      // invalid_address: false,
      autocompleteOptions: {
        componentRestrictions: {
          country: ["ie", "gb"],
        },
        types: ["postal_code"],
      },
      selected_business_hours_index: null,
      days: null,
    };
  },
  mounted() {
    // console.log(JSON.stringify(days_default));
    console.log(this.locations);
  },
  methods: {
    addLocation() {
      this.locations.push({
        id: "new",
        address: "",
        post_code: "",
        latitude: "",
        longitude: "",
        country: "",
        county: "",
        business_hours: "",
        business_hours_json: "",
        invalid_country: false,
        invalid_county: false,
        invalid_post_code: false,
        invalid_address: false,
        invalid_business_hours: false,
      });
      // this.timer = setTimeout(() => {
      //     this.addAutoCompleteInput();
      //     this.addBusinessHoursContainer();
      // }, 500)
    },

    removeLocation(index) {
      this.locations.splice(index, 1);
    },
    setPlace(place) {
      // console.log("place ");
      // console.log(place);
      // console.log(place.name);
      // console.log(place.geometry.location.lat());
      // console.log(place.geometry.location.lng());
      // this.address = $("#address").val();
      // this.address_coordinates = {
      //   lat: place.geometry.location.lat(),
      //   lng: place.geometry.location.lng(),
      // };
      //   this.setAddress($("#address").val());
      //   this.setAddressCoordinates({
      //     lat: place.geometry.location.lat(),
      //     lng: place.geometry.location.lng(),
      //   });
    },
    inputChange(place, id) {
      console.log(place);
      console.log(id);
      let index = id.split("_")[2];
      console.log(index);
      this.locations[index - 1].post_code = place.newVal;
    },
    changeT( id) {
      console.log(id);
      console.log( )
        let index = id.split("_")[2];
      console.log(index);
      this.locations[index - 1].post_code = $("#"+id).val();
    },
    savePlace(place, placeResultData, id) {
      console.log(place);
      console.log(placeResultData);
      console.log(id);
      // console.log(place.latitude, place.longitude);
      // console.log(
      //   placeResultData.geometry.location.lat(),
      //   placeResultData.geometry.location.lng()
      // );
      let index = id.split("_")[2];
      console.log(index);
      this.locations[index - 1].post_code = placeResultData.name;
      this.locations[index - 1].address = placeResultData.formatted_address;
      this.locations[index - 1].latitude = place.latitude;
      this.locations[index - 1].longitude = place.longitude;
      // console.log(this.locations);
      $("#" + id).val(placeResultData.name);
    },
    handleError(error) {
      alert(error);
    },
    openBusinessHoursModel(index) {
      // console.log("click business hours ", index);
      this.selected_business_hours_index = index;
      // console.log(days_default);
      if (
        this.locations[index].business_hours != null &&
        this.locations[index].business_hours != ""
      ) {
        this.days = JSON.parse(this.locations[index].business_hours_json);
      } else {
        this.days = structuredClone(days_default);
      }
      this.$root.$emit("bv::show::modal", "business-hours-doorder-modal");
    },
    clickConfirm() {
      // console.log(this.days);
      // this.availability = this.days;

      let temp = "";
      Object.keys(this.days).forEach((key) => {
        // console.log(key, this.days[key]);
        if (this.days[key][0].isOpen) {
          temp += key.charAt(0).toUpperCase() + key.slice(1) + ": ";

          this.days[key].forEach(function (element, index) {
            // console.log(element, index, typeof element.open);
            if (element.open != "24hrs") {
              temp +=
                moment(element.open, "HHmm").format("hh:mm a") +
                " - " +
                moment(element.close, "HHmm").format("hh:mm a");
            } else {
              temp += element.open + " - " + element.close;
            }

            temp += "/";
          });

          temp += " ";
          // temp += "\n";
        }
      });
      this.locations[this.selected_business_hours_index].business_hours = temp;
      // this.locations[this.selected_business_hours_index].days = this.days;
      this.locations[this.selected_business_hours_index].business_hours_json =
        JSON.stringify(this.days);
      // this.$refs['business-hours-doorder-modal'].hide()
      this.$bvModal.hide("business-hours-doorder-modal");
      // console.log(this.locations);
    },
    closeModal() {
      this.$bvModal.hide("business-hours-doorder-modal");
    },
    updatedHours: function (val) {
      // do whatever you want here
      // console.log(val);
      // console.log(this.days);
    },
  },
};
</script>

<style >
@media screen and (min-width: 576px) {
  #business-hours-doorder-modal .modal-dialog {
    margin-top: 100px;
    max-width: 85%;
    width: 85%;
  }
  .modal-dialog-scrollable {
    height: calc(100% - 10rem);
  }
}
@media screen and (min-width: 768px) {
  #business-hours-doorder-modal .modal-dialog {
    max-width: 65%;
    width: 65%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/doorder/retailers/profile_details_components/LocationDetails.vue